"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var UIUtils_1 = require("../../../shared/modules/UIUtils");
var BaseController_1 = require("../../../shared/controllers/BaseController");
var webAApi_1 = require("../../api/webAApi");
var ListTopWinnersDatesAvailCtl = /** @class */ (function (_super) {
    __extends(ListTopWinnersDatesAvailCtl, _super);
    function ListTopWinnersDatesAvailCtl(errDialog) {
        var _this = _super.call(this, true) || this;
        _this.dk_value = UIUtils_1.UIUtils.IProp2Str(function (o) { o.value; });
        _this.dk_key = UIUtils_1.UIUtils.IProp2Str(function (o) { o.key; });
        _this._errDialog = errDialog;
        return _this;
    }
    ListTopWinnersDatesAvailCtl.prototype.ResetData = function () {
        this.DATA = {
            years_avail: [],
            month_avail: []
        };
    };
    ListTopWinnersDatesAvailCtl.prototype.getYearById = function (id) {
        for (var i = 0; i < this.DATA.years_avail.length; i++) {
            if (this.DATA.years_avail[i].key === id) {
                return this.DATA.years_avail[i];
            }
        }
        return null;
    };
    ListTopWinnersDatesAvailCtl.prototype.getMonthById = function (id) {
        for (var i = 0; i < this.DATA.month_avail.length; i++) {
            if (this.DATA.month_avail[i].key === id) {
                return this.DATA.month_avail[i];
            }
        }
        return null;
    };
    ListTopWinnersDatesAvailCtl.prototype.LoadData = function (onDone) {
        var _this = this;
        webAApi_1.ListWinnersYearAndMonthAvail.exec({}, function (resp) {
            _this.DATA.years_avail = [];
            _this.DATA.month_avail = [];
            for (var i = 0; i < resp.years_avail.length; i++) {
                _this.DATA.years_avail.push({
                    key: resp.years_avail[i].key_uid,
                    value: resp.years_avail[i].title,
                });
            }
            for (var i = 0; i < resp.month_avail.length; i++) {
                _this.DATA.month_avail.push({
                    key: resp.month_avail[i].key_uid,
                    value: resp.month_avail[i].title,
                });
            }
            _this.Update();
            if (onDone) {
                onDone();
            }
        }, function (err) {
            _this._errDialog.ShowApiError(err);
        });
    };
    return ListTopWinnersDatesAvailCtl;
}(BaseController_1.BaseController));
exports.ListTopWinnersDatesAvailCtl = ListTopWinnersDatesAvailCtl;



//////////////////
// WEBPACK FOOTER
// ./src/ui_admin/shared/controllers/ListTopWinnersDatesAvailCtl.ts
// module id = 2082
// module chunks = 0